import * as React from 'react';
import { useSelector } from 'react-redux';
import { branchenSelector } from 'store/lookups/selector';
import { requestBranchen } from 'store/lookups/actions';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { DefaultButton, Dialog, DialogFooter, DialogType, Fabric, PrimaryButton } from '@fluentui/react';
import { viewStyles } from 'styles/viewStyles';
import { formStyles } from 'styles/formStyles';
import { FormTextField } from 'formComponents/FormTextField';
import { SavingState } from 'api/savingState';
import { addBranche, defaultBranche, Branche, updateBranche } from 'api/branche';

const styles = mergeStyleSets({
    container: {
        position: 'relative',
        height: 'calc(100vh - 120px)',
        display: 'grid',
        gridTemplateRows: 'max-content 1fr',
        gridRowGap: 10,
    },
    searchBar: {
        display: 'grid',
        gridTemplateColumns: '1fr max-content',
        gridColumnGap: 10,
        marginTop: 10,
    },
});

export const Branchen: React.FC = () => {
    const branchen = useSelector(branchenSelector);

    const [editData, setEditData] = React.useState<Branche | null>(null);

    const save = async () => {
        if (!editData) {
            return;
        }
        if (editData?.nr === -1) {
            await addBranche(editData);
        } else {
            await updateBranche(editData);
        }
        await requestBranchen();
        setEditData(null);
    };

    return (
        <Fabric className={styles.container}>
            <div className={styles.searchBar}>
                <div />

                <PrimaryButton onClick={() => setEditData({ ...defaultBranche, nr: -1 })} text="Neue Branche" />
            </div>
            <div className={viewStyles.listContainerScroll}>
                <table className={formStyles.lookupTable}>
                    <thead className={formStyles.lookupTableHead}>
                        <tr>
                            <td className={formStyles.lookupTableCell}>Text</td>
                            <td className={formStyles.lookupTableCell} />
                        </tr>
                    </thead>
                    <tbody className={formStyles.lookupTableBody}>
                        {branchen.map((branche) => (
                            <tr key={branche.nr} className={formStyles.looupTableRow}>
                                <td className={formStyles.lookupTableCell}>{branche.text}</td>
                                <td className={formStyles.lookupTableActionCell}>
                                    <DefaultButton
                                        className={formStyles.lookupTableEditButton}
                                        onClick={() => setEditData({ ...branche })}
                                        text="Bearbeiten"
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {editData && (
                <Dialog
                    hidden={false}
                    minWidth={800}
                    dialogContentProps={{
                        title: 'Branche bearbeiten',
                        type: DialogType.normal,
                    }}
                >
                    <FormTextField
                        value={editData.text}
                        savingState={SavingState.notChanged}
                        options={{}}
                        onChange={(newValue): void => {
                            if (editData) {
                                setEditData({
                                    ...editData,
                                    text: newValue as string,
                                });
                            }
                        }}
                        label="Name"
                    />
                    <DialogFooter>
                        <DefaultButton onClick={() => setEditData(null)} text="Abbruch" />
                        <PrimaryButton onClick={save} text="Speichern" />
                    </DialogFooter>
                </Dialog>
            )}
        </Fabric>
    );
};
